import { LocationDto } from "src/dtos/location/locationDto";
import { WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";

export interface WMS2060_R01Dto extends WmsStockLotDto {
	
	logicCenter: string;
	logicCenterNm: string;
	updateLotQty: number; // 실재고 입력값
	movedLotQty: number; // 이동재고량 표시값

}

export const defaultWMS2060_R01Dto: WMS2060_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',

	logicCenter: '',
	logicCenterNm: '',
	updateLotQty: 0,
	movedLotQty: 0,
	
	inserted: false,
	isModified: false,
}